export const teacherClass = {
    "teacher_class_my_classes": "我的班级",
    "teacher_class_search_placeholder": "搜索班级名称或描述",
    "teacher_class_no_classes": "暂无班级",
    "teacher_class_view_detail": "查看详情",
    "teacher_class_start_time": "开始时间",
    "teacher_class_end_time": "结束时间",
    "teacher_class_status_init": "初始化",
    "teacher_class_status_running": "进行中",
    "teacher_class_status_end": "已结束",
    "teacher_class_status_disabled": "已禁用",
    "teacher_class_status_completed": "已完成",
    "teacher_class_status_wait_grade": "等待批改",
    "teacher_class_status_submitted": "已提交",
    "teacher_class_status_in_progress": "进行中",
    "teacher_class_msg_fetch_error": "获取班级列表失败",
    "teacher_class_msg_fetch_detail_error": "获取班级详情失败",
    "teacher_class_msg_fetch_students_error": "获取学生列表失败",
    "teacher_class_msg_fetch_homeworks_error": "获取作业列表失败",
    "teacher_class_msg_fetch_homework_banks_error": "获取作业库失败",
    "teacher_class_msg_fetch_homework_details_error": "获取作业详情失败",
    "teacher_class_msg_create_homework_success": "创建作业成功",
    "teacher_class_msg_create_homework_error": "创建作业失败",
    "teacher_class_msg_delete_homework_success": "删除作业成功",
    "teacher_class_msg_delete_homework_error": "删除作业失败",
    "teacher_class_msg_update_homework_success": "更新作业成功",
    "teacher_class_msg_update_homework_error": "更新作业失败",
    "teacher_class_msg_select_homework_temp": "请选择作业模板",
    "teacher_class_msg_select_subject": "请选择科目",
    "teacher_class_detail_basic_info": "基本信息",
    "teacher_class_detail_teachers": "老师",
    "teacher_class_detail_students": "学生",
    "teacher_class_detail_homeworks": "作业",
    "teacher_class_detail_statistics": "统计",
    "teacher_class_detail_name": "班级名称",
    "teacher_class_detail_status": "状态",
    "teacher_class_detail_start_time": "开始时间",
    "teacher_class_detail_end_time": "结束时间",
    "teacher_class_detail_desc": "描述",
    "teacher_class_no_teachers": "暂无老师",
    "teacher_class_no_students": "暂无学生",
    "teacher_class_no_homeworks": "暂无作业",
    "teacher_class_no_homework_banks": "暂无作业库",
    "teacher_class_no_statistics": "暂无统计数据",
    "teacher_class_column_name": "姓名",
    "teacher_class_column_email": "邮箱",
    "teacher_class_column_remark_name": "备注名",
    "teacher_class_column_subjects": "科目",
    "teacher_class_column_subject": "科目",
    "teacher_class_column_description": "描述",
    "teacher_class_column_status": "状态",
    "teacher_class_column_actions": "操作",
    "teacher_class_column_homework_name": "作业名称",
    "teacher_class_column_total_students": "总学生数",
    "teacher_class_column_answered_count": "已回答数",
    "teacher_class_column_unanswered_count": "未回答数",
    "teacher_class_column_has_answer": "已回答",
    "teacher_class_column_score": "得分",
    "teacher_class_column_answer_id": "答案ID",
    "teacher_class_create_homework": "下发作业",
    "teacher_class_view_details": "查看详情",
    "teacher_class_enable": "启用",
    "teacher_class_disable": "禁用",
    "teacher_class_enabled": "已启用",
    "teacher_class_disabled": "待启用",
    "teacher_class_delete": "删除",
    "teacher_class_delete_disabled_tooltip": "该作业已有学生提交，无法删除",
    "teacher_class_edit_name": "修改名称",
    "teacher_class_edit_homework_name": "修改作业名称",
    "teacher_class_save": "保存",
    "teacher_class_all_subjects": "全部科目",
    "teacher_class_search_homework": "搜索作业",
    "teacher_class_modal_title": "班级详情：{{name}}",
    "teacher_class_homework_details": "作业详情",
    "teacher_class_homework_basic_info": "作业基本信息",
    "teacher_class_homework_use_time": "预计用时",
    "teacher_class_minutes": "分钟",
    "teacher_class_student_completion_stats": "学生完成情况统计",
    "teacher_class_total_students": "总学生数",
    "teacher_class_answered_count": "已回答",
    "teacher_class_unanswered_count": "未回答",
    "teacher_class_average_score": "平均分",
    "teacher_class_student_answers": "学生答案列表",
    "teacher_class_total": "共 {{total}} 条",
    "teacher_class_yes": "是",
    "teacher_class_no": "否",
    "teacher_class_no_data": "暂无数据",
    "teacher_class_select_subject": "选择科目",
    "teacher_class_select_subject_placeholder": "请选择科目",
    "teacher_class_select_homework_temp": "选择作业模板",
    "teacher_class_homework_name": "作业名称",
    "teacher_class_homework_name_placeholder": "留空则使用模板名称",
    "teacher_class_homework_description": "作业描述",
    "teacher_class_homework_description_placeholder": "请输入作业描述",
    "teacher_class_homework_enable": "立即启用",
    "teacher_class_stat_total_homework": "总作业数",
    "teacher_class_stat_enabled_homework": "已启用作业",
    "teacher_class_stat_disabled_homework": "待启用作业",
    "teacher_class_stat_student_count": "学生总数",
    "loading": "加载中...",
    "teacher_class_enter_class": "进入班级",
    "teacher_class_go_to_class_manager": "前往班级管理",
    "teacher_class_go_to_class_manager_desc": "管理员可在此管理所有班级、老师与学生",
    "teacher_class_view_mode_cards": "卡片视图",
    "teacher_class_view_mode_list": "列表视图",
    "teacher_class_student_count": "学生数量",
    "teacher_class_detail_info": "班级详情",
    "teacher_class_homework_list": "作业列表",
    "teacher_class_homework_bank": "作业库",
    "teacher_class_homework_template": "作业模板",
    "teacher_class_view_homework_bank": "查看作业库",
    "teacher_class_view_template": "查看模板",
    "teacher_class_select_template": "选择模板",
    "teacher_class_bank_type_public": "公共作业库",
    "teacher_class_bank_type_teacher": "个人作业库",
    "teacher_class_bank_type_class": "班级作业库",
    "teacher_class_bank_list": "作业库列表",
    "teacher_class_template_list": "作业模板列表",
    "teacher_class_search_template": "搜索模板名称",
    "teacher_class_search_homework_bank": "搜索作业库名称或描述",
    "teacher_class_no_templates_search_empty": "未找到匹配的模板",
    "teacher_class_no_homework_banks_search_empty": "未找到匹配的作业库",
    "teacher_class_back": "返回",
    "teacher_class_select": "选择",
    "teacher_class_view_detail_btn": "查看详情",
    "teacher_class_create_homework_sub": "创建作业",
    "teacher_class_create": "创建",
    "teacher_class_cancel": "取消",
    "teacher_class_no_homework_banks_empty": "暂无作业库",
    "teacher_class_no_templates_empty": "该作业库暂无模板",
    "teacher_class_no_template_content": "暂无模板内容",
    "teacher_class_template_detail": "作业模板详情",
    "teacher_class_msg_load_public_banks_error": "加载公共作业库失败",
    "teacher_class_msg_load_teacher_banks_error": "加载个人作业库失败",
    "teacher_class_msg_load_class_banks_error": "加载班级作业库失败",
    "teacher_class_msg_load_templates_error": "加载模板列表失败",
    "teacher_class_msg_load_template_detail_error": "加载模板详情失败",
    "teacher_class_msg_select_bank_first": "请先选择作业库",
    "teacher_class_msg_load_data_error": "加载数据失败",
    "teacher_class_msg_get_class_info_error": "获取班级信息失败",
    "teacher_class_msg_no_subject_permission": "无法下发作业",
    "teacher_class_msg_no_subject_permission_desc": "您在该班级中没有分配科目，请联系管理员分配科目后即可下发作业。",
    "teacher_class_msg_template_selected": "已选择模板，请填写作业信息",
    "teacher_class_msg_homework_name_required": "请输入作业名称",
    "teacher_class_view_student_info": "查看学生信息",
    "teacher_class_view_student_info_msg": "查看学生 {{name}} 的信息",
    "teacher_class_view_answer_detail": "查看答案详情",
    "teacher_class_select_student_to_view": "请先选择学生查看答案详情",
    "teacher_class_student_no_answer": "该学生尚未提交答案",
    "teacher_class_answer_basic_info": "答案基本信息",
    "teacher_class_questions_and_answers": "题目与答案",
    "teacher_class_student_answer": "学生答案",
    "teacher_class_question_score": "得分",
    "teacher_class_true": "正确",
    "teacher_class_false": "错误",
    "teacher_class_no_answer": "未作答",
    "teacher_class_homework_questions": "作业题目",
    "teacher_class_student_answer_detail": "学生答案详情",
    "teacher_class_wait_read": "待批阅",
    "teacher_class_msg_fetch_student_answer_error": "获取学生答案详情失败",
    "teacher_class_grade_btn": "批改",
    "teacher_class_grade_title": "批改作业",
    "teacher_class_grade_correct": "正确",
    "teacher_class_grade_incorrect": "错误",
    "teacher_class_grade_half_correct": "部分正确",
    "teacher_class_grade_custom": "自定义",
    "teacher_class_grade_correctness": "正确性",
    "teacher_class_grade_score": "分数",
    "teacher_class_grade_desc": "批改备注",
    "teacher_class_grade_desc_placeholder": "输入批改备注（可选）",
    "teacher_class_grade_submit": "提交批改",
    "teacher_class_grade_no_need": "暂无需要批改的题目",
    "teacher_class_grade_no_answer": "答案记录不存在",
    "teacher_class_grade_success": "批改成功",
    "teacher_class_grade_error": "批改失败",
    "teacher_class_grade_pending_title": "待批改作业",
    "teacher_class_grade_pending_count": "待批改数",
    "teacher_class_grade_pending_unit": "份",
    "teacher_class_grade_no_pending": "暂无待批改作业",
    "teacher_class_grade_load_error": "加载待批改列表失败",
    "teacher_class_grade_class": "班级",
    "teacher_class_stat_completed": "已完成",
    "teacher_class_stat_completion_rate": "完成率",
    "teacher_class_stat_avg_score_rate": "平均得分率",
    "teacher_class_stat_ranking": "学生排名",
    "teacher_class_stat_rank": "排名",
    "teacher_class_stat_total_score": "总分",
    "teacher_class_stat_avg_completion": "平均完成率",
    "teacher_class_stat_homework_count": "作业数",
    "teacher_class_stat_homework_score_chart": "各作业平均得分率",
    "teacher_class_stat_finished": "人已完成",
    "teacher_class_student_detail_stats": "学生详情统计",
    "teacher_class_no_subject_stats": "暂无该科目的作业统计",
    "teacher_class_filter_all": "全部",
    "teacher_class_filter_wait_grade": "待批改",
    "teacher_class_filter_completed": "已完成",
    "teacher_class_filter_in_progress": "进行中",
    "teacher_class_filter_no_answer": "未作答",
    "teacher_class_answer_statistics_tab": "答案统计",
    "teacher_class_answer_detail_tab": "答题详情",
    "teacher_class_grade_list_title": "待批改列表",
    "teacher_class_grade_regrade_btn": "重新批改",
    "teacher_class_grade_regrade_title": "重新批改作业",
    "teacher_class_grade_regrade_warning": "该作业已批改完成，您正在进行重新批改，提交后将覆盖原有批改结果。",
    "teacher_class_grade_regrade_confirm_title": "确认重新批改",
    "teacher_class_grade_regrade_confirm_content": "重新批改将覆盖该学生原有的批改分数和备注，是否继续？",
    "teacher_class_grade_page_title": "批改作业",
    "teacher_class_grade_show_auto_scored": "显示客观题（只读，不可批改）",
    "teacher_class_grade_auto_scored_tag": "自动批改",
    "teacher_class_grade_needs_grade_tag": "待批改",
};
